/** Enrollment statuses that grant access when backend flag is absent. */
export const ACCESSIBLE_ENROLLMENT_STATUSES = ['approved', 'completed']

export function canAccessCourseContent(enrollment) {
    if (!enrollment) return false
    if (typeof enrollment.can_access_course === 'boolean') {
        return enrollment.can_access_course
    }
    return ACCESSIBLE_ENROLLMENT_STATUSES.includes(enrollment.status)
}

export function isCourseEnrolled(enrollment) {
    return canAccessCourseContent(enrollment)
}

export function isEnrollmentCompleted(enrollment) {
    if (!enrollment) return false
    // Only explicit completed status unlocks certificates — lesson progress alone is not enough
    // when the course has required assessments.
    return enrollment.status === 'completed'
}

/** Pick the best enrollment record for a course from a list. */
export function findCourseEnrollment(enrollments) {
    const list = Array.isArray(enrollments) ? enrollments : []
    return (
        list.find((e) => canAccessCourseContent(e))
        || list.find((e) => e.status === 'pending')
        || list[0]
        || null
    )
}

export function hasAccessibleEnrollment(enrollments, courseId) {
    return enrollments.some(
        (e) => e.course === courseId && canAccessCourseContent(e)
    )
}
